export const CURRENCY_SIGN_MAP: Record<string, string> = {
  usd: '$',
  eur: '€',
  inr: '₹',
  gbp: '£'
}
